import React from "react";
import { Grid, Paper, Typography } from "@mui/material";

const StatsCards = ({
  inTransitCount,
  receivedCount,
  cancelledCount,
  rejectedCount,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6} sm={3}>
        <Paper sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h4" color="warning.main" fontWeight="bold">
            {inTransitCount}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            In Transit
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Paper sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h4" color="success.main" fontWeight="bold">
            {receivedCount}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Received
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Paper sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h4" color="error.main" fontWeight="bold">
            {cancelledCount}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Cancelled
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Paper sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h4" color="warning.main" fontWeight="bold">
            {rejectedCount}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Rejected
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default StatsCards;
